import { useEffect } from "react";
import Seo from "@/components/Seo";

/**
 * Full-screen landing page hosting the involve.me embed.
 *
 * The base Meta Pixel keeps firing PageView via `index.html`. No header,
 * no footer, no other content on the page.
 */
export default function InvolveLandingFB() {
  useEffect(() => {
    const SRC = "https://venditore-a-distanza-srls.involve.me/embed";
    if (document.querySelector(`script[src="${SRC}"]`)) {
      return;
    }
    const s = document.createElement("script");
    s.src = SRC;
    s.async = true;
    document.body.appendChild(s);
  }, []);

  return (
    <>
      <Seo
        title="Lovac"
        description="Prenota una call con Lovac."
        path="/lp/prenota-call-fb"
        noindex
      />
      <div
        className="involveme_embed"
        data-project="lovac-prenota-call"
        data-title="Involve Lovac Prenota Call - FB"
        data-testid="involveme-embed"
        style={{ minHeight: "100vh", width: "100%" }}
      />

      <footer className="footer-dark" data-testid="involve-lp-footer">
        <div className="container-lovac px-6 py-10">
          <div className="grid md:grid-cols-2 gap-6">
            <div className="text-xs text-on-dark-muted leading-relaxed">
              <p className="text-on-dark font-medium mb-2">Venditore a Distanza Srl</p>
              <p>Via Zoe Fontana 220, 00131 Roma (RM)</p>
              <p>P.IVA 15627561002</p>
              <p className="mt-2">
                Accreditamento ai Servizi per il Lavoro, Regione Lazio<br />
                Determinazione n. G04261
              </p>
            </div>
            <div className="text-xs text-on-dark-muted md:text-right">
              <p>© {new Date().getFullYear()} Lovac</p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
